export const TOKEN_LIMIT_INPUT = 4000;

export const PROJECT_OPTIONS = [
  { label: "io.intelligence", value: "io-intelligence" },
  { label: "io.cloud", value: "io-cloud" }
];

export const INTELLIGENCE_PLAN_NAME = "Professional";
export const INTELLIGENCE_DEVELOPER_PLAN_NAME = "Developer";

export const HIGHER_TIER_REQUIRED_MESSAGE =
  "This model isn't available on your current plan. Try buying credits or upgrading your plan to unlock it.";

export const INTELLIGENCE_PLANS_PATH = "/ai/plans";
